export interface NewsItemIdResponseApi {
  newsId: string;
}

export let isNewsItemIdResponseDTO = (
  variable: unknown
): variable is NewsItemIdResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "newsId" in variable &&
    typeof variable.newsId === "string"
  );
};
